export default __webpack_public_path__ + "static/media/intec_bg_login.8f46383a.jpg";